// extracted by mini-css-extract-plugin
export var container = "_tk-0";
export var table = "_tk-2";
export var tableWrapper = "_tk-1";